export default "__VITE_ASSET__5ohPr6JV__"